import { apiSlice } from './api';
import { ResponseBody } from '../types/common';

export const linkApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLink: builder.query({
      query: (link) => `link/${link}`,
      transformResponse: (res: ResponseBody) => res.data,
    }),
  }),
});

export const { useGetLinkQuery } = linkApiSlice;
